import {Modal} from 'antd';

export const confirmIfAgentServiceMismatch = ({
  agentId,
  agentName,
  serviceAgents,
  serviceName,
  intl,
  onConfirm,
}: {
  agentId: string | number | undefined;
  agentName: string;
  serviceAgents: Array<{ id?: string | number; isWholeService?: boolean }>;
  serviceName: string;
  intl: any;
  onConfirm: () => void;
}) => {
  // Strip the synthetic "Any available agent" entry that the cascader injects
  const realAgents = (serviceAgents || []).filter(a => !a.isWholeService);

  if (!agentId) {
    onConfirm();
    return;
  }
  if (realAgents.length > 0 && realAgents.some(a => `${a.id}` === `${agentId}`)) {
    onConfirm();
    return;
  }
  Modal.confirm({
    title: intl.formatMessage({
      id: 'pages.serviceRequest.agentServiceMismatch.title',
      defaultMessage: 'Agent does not provide this service',
    }),
    content: intl.formatMessage(
      {
        id: 'pages.serviceRequest.agentServiceMismatch.description',
        defaultMessage: '"{agentName}" does not provide "{serviceName}". The appointment will still be saved with this assignment.',
      },
      { agentName, serviceName },
    ),
    okText: intl.formatMessage({
      id: 'pages.serviceRequest.agentServiceMismatch.confirm',
      defaultMessage: 'Assign anyway',
    }),
    onOk: onConfirm,
  });
};
